import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fetchFeatured = async () => {
  const r = await api.get("/destinations/featured");
  return r.data.items || [];
};

export const fetchItinerary = async (id) => {
  const r = await api.get(`/itinerary/${id}`);
  return r.data;
};

export const generateItinerary = async (promptOrPayload) => {
  const payload = typeof promptOrPayload === "string"
    ? { prompt: promptOrPayload }
    : promptOrPayload;
  const r = await api.post("/itinerary/generate", payload);
  return r.data;
};

export const saveItinerary = async (itin) => {
  const r = await api.post("/itinerary/save", { itinerary: itin });
  return r.data;
};

export const listSaved = async () => {
  const r = await api.get("/itinerary");
  return r.data.items || [];
};

export const deleteSaved = async (id) => {
  const r = await api.delete(`/itinerary/${id}`);
  return r.data;
};

export const copilotChat = async ({ message, itinerary_id, session_id }) => {
  const r = await api.post("/copilot/chat", { message, itinerary_id, session_id });
  return r.data;
};

export const generateMoodboard = async (itineraryId, { regenerate = false } = {}) => {
  const r = await api.post(
    `/itinerary/${itineraryId}/moodboard${regenerate ? "?regenerate=true" : ""}`,
    {},
    { timeout: 120000 }
  );
  return r.data;
};

export const fetchMoodboard = async (itineraryId) => {
  try {
    const r = await api.get(`/itinerary/${itineraryId}/moodboard`);
    return r.data;
  } catch (e) {
    if (e?.response?.status === 404) return null;
    throw e;
  }
};

export const fetchMe = async () => {
  const r = await api.get("/auth/me");
  return r.data;
};

export const exchangeSession = async (sessionId) => {
  const r = await api.post("/auth/google/session", { session_id: sessionId });
  return r.data;
};

export const logout = async () => {
  const r = await api.post("/auth/logout");
  return r.data;
};
